import { useFeatureFlags } from '#src/hooks/useFeatureFlags.tsx';

export const useEnableArcadeManagerProfile = () => {
  const {
    flags: { enableArcadeManagerProfile = false },
  } = useFeatureFlags();

  return !!enableArcadeManagerProfile;
};
